import {
    PayablesSortColumn,
    SupplierUtilizationSortColumn,
    TransferDetailSortColumn,
    TransfersSortColumn
} from '../model/models';

export function mapBuyerPayableSortColumn(sortColumn: string): PayablesSortColumn {
    switch (sortColumn) {
        case 'buyerName':
            return PayablesSortColumn.BUYER_NAME;
        case 'sellerName':
            return PayablesSortColumn.SUPPLIER_NAME;
        case 'invoiceNumber':
        case 'groupId':
            return PayablesSortColumn.NAME;
        case 'invoiceDate':
        case 'invoiceDateNew':
            return PayablesSortColumn.INVOICE_DATE;
        case 'fundingDate':
            return PayablesSortColumn.EARLY_PAYMENT_DATE;
        case 'invoiceDueDate':
        case 'invoiceDueDateNew':
            return PayablesSortColumn.DUE_DATE;
        case 'finalApprovedAmount':
            return PayablesSortColumn.AMOUNT;
        case 'buyerDiscountPercentage':
            return PayablesSortColumn.BUYER_DISCOUNT_FEE_RATE;
        case 'buyerDiscountAmount':
            return PayablesSortColumn.BUYER_DISCOUNT_FEE;
        case 'discountAmount':
        case 'supplierDiscountAmount':
            return PayablesSortColumn.SUPPLIER_DISCOUNT_FEE;
        case 'feeRateHundredthOfBps':
            return PayablesSortColumn.SUPPLIER_DISCOUNT_FEE_RATE;
        // TODO: Refactor to use buyerStatus and supplierStatus.
        case 'earlyPaymentStatus':
        case 'invoiceStatus':
        case 'fundingStatus':
            return PayablesSortColumn.STATUS_LEGACY;
        case 'estimatedPayLaterFee':
            return PayablesSortColumn.PAY_LATER_FEE;
        case 'payLaterDueDate':
            return PayablesSortColumn.PAY_LATER_DUE_DATE;
        case 'estimatedPayLaterDueDate':
            return PayablesSortColumn.ESTIMATED_PAY_LATER_DUE_DATE;
        case 'earlyPaymentDate':
            return PayablesSortColumn.EARLY_PAYMENT_DATE;
        case 'payLaterFee':
            return PayablesSortColumn.PAY_LATER_FEE;
        case 'dueIn':
            return PayablesSortColumn.DUE_IN;
        case 'invoiceAmount':
        case 'availableAmount':
            return PayablesSortColumn.AMOUNT;
        case 'termsExtensionDays':
            return PayablesSortColumn.PAYABLE_TERM_EXTENSION_DAYS;
    }
    return PayablesSortColumn.DUE_DATE;
}

export function mapBuyerTransferSortColumn(sortColumn: string): TransfersSortColumn {
    switch (sortColumn) {
        case 'status':
            return TransfersSortColumn.STATUS;
        case 'referenceNumber':
            return TransfersSortColumn.TRACE_NUMBER;
        case 'payer':
            return TransfersSortColumn.PAYER_NAME;
        case 'recipient':
            return TransfersSortColumn.RECIPIENT_TYPE;
        case 'paymentDate':
            return TransfersSortColumn.DATE;
        case 'paymentType':
            return TransfersSortColumn.TYPE;
        case 'numberOfInvoices':
            return TransfersSortColumn.PAYABLE_COUNT;
        case 'paymentAmount':
            return TransfersSortColumn.AMOUNT;
    }
    return TransfersSortColumn.DATE;
}

export function mapSupplierTransferSortColumn(sortColumn: string): TransfersSortColumn {
    switch (sortColumn) {
        case 'fundingDate':
            return TransfersSortColumn.DATE;
        case 'status':
            return TransfersSortColumn.TYPE;
        case 'fundingStatus':
            return TransfersSortColumn.STATUS;
        case 'invoiceCount':
            return TransfersSortColumn.PAYABLE_COUNT;
        case 'totalApprovedAmount':
            return TransfersSortColumn.APPROVED_INVOICE_AMOUNT;
        case 'totalDiscountAmount':
            return TransfersSortColumn.TOTAL_DISCOUNT_FEE;
        case 'buyerDiscountAmount':
            return TransfersSortColumn.BUYER_DISCOUNT_FEE;
        case 'supplierDiscountAmount':
            return TransfersSortColumn.SUPPLIER_DISCOUNT_FEE;
        case 'totalFundingAmount':
            return TransfersSortColumn.AMOUNT;
    }
    return TransfersSortColumn.DATE;
}

export function mapSupplierUtilizationSortColumn(
    sortColumn: string
): SupplierUtilizationSortColumn {
    switch (sortColumn) {
        case 'sellerId':
            return SupplierUtilizationSortColumn.SELLER_ID;
        case 'name':
            return SupplierUtilizationSortColumn.NAME;
        case 'earlyPaidAmount':
            return SupplierUtilizationSortColumn.EARLY_PAID_AMOUNT;
        case 'openInvoiceAmount':
            return SupplierUtilizationSortColumn.OPEN_INVOICE_AMOUNT;
        case 'percentUsed':
            return SupplierUtilizationSortColumn.PERCENT_USED;
        case 'enrollmentStatus':
            return SupplierUtilizationSortColumn.ENROLLMENT_STATUS;
        case 'buyerName':
            return SupplierUtilizationSortColumn.BUYER_NAME;
        case 'buyerKey':
            return SupplierUtilizationSortColumn.BUYER_KEY;
        case 'sellerKey':
            return SupplierUtilizationSortColumn.SELLER_KEY;
    }
    return SupplierUtilizationSortColumn.NAME;
}

export function mapTranferDetailsSortColumn(sortColumn: string): TransferDetailSortColumn {
    switch (sortColumn) {
        case 'supplierLegalName':
            return TransferDetailSortColumn.PAYEE_NAME;
        case 'paymentType':
            return TransferDetailSortColumn.TYPE;
        case 'recipient':
            return TransferDetailSortColumn.RECIPIENT;
        case 'invoiceDate':
            return TransferDetailSortColumn.INVOICE_DATE;
        case 'earlyPaymentDate':
            return TransferDetailSortColumn.EARLY_PAYMENT_DATE;
        case 'paymentDate':
            return TransferDetailSortColumn.PAYMENT_DATE;
        case 'payLaterDate':
            return TransferDetailSortColumn.PAY_LATER_DATE;
        case 'invoiceAmount':
            return TransferDetailSortColumn.INVOICE_AMOUNT;
        case 'buyerFundingChargeTotal':
            return TransferDetailSortColumn.BUYER_TRANSACTION_FEE;
        case 'buyerFundingChargePaidTotal':
            return TransferDetailSortColumn.BUYER_TRANSACTION_PAID_FEES;
        case 'paymentAmount':
            return TransferDetailSortColumn.AMOUNT;
        case 'invoiceNumber':
        default:
            return TransferDetailSortColumn.INVOICE_DATE;
    }
}
